import { render, staticRenderFns } from "./QuestionCatheterization.vue?vue&type=template&id=4ca60616&scoped=true"
import script from "./QuestionCatheterization.vue?vue&type=script&lang=js"
export * from "./QuestionCatheterization.vue?vue&type=script&lang=js"
import style0 from "./QuestionCatheterization.vue?vue&type=style&index=0&id=4ca60616&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca60616",
  null
  
)

export default component.exports